import React from 'react';
import BaseComponent from '../../baseClasses/BaseComponent';

import './VideoPlayer.scss';

class VideoPlayer extends BaseComponent {

  releaseObjectURL() {
    if (this.urlObject) {
      URL.revokeObjectURL(this.urlObject);
      this.urlObject = null;
    }
  }

  componentWillUnmount() {
    this.releaseObjectURL();
  }

  render(){
    const { src, type, width, height, alt } = this.props;

    let vidWidth = width ? width : 700;
    let vidHeight = height ? height : 328;
    let vidText = alt ? alt : 'Your browser doesn\'t support the video tag';
    const videoType = type ? type : 'video/mp4';
    let url = src;
    if (url instanceof Blob) {
      this.releaseObjectURL();
      url = URL.createObjectURL(url);
      this.urlObject = url;
    }
    
    return (
      <div className='video-container'>
        <video controls="controls" width={vidWidth} height={vidHeight} name="Video Name" src={url} onLoadedData={this.props.onLoad}>
    <source src={url} type={videoType}/>
  {vidText}
        </video>
      </div>
    );
  }
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/index.js